export default "__VITE_ASSET__da313320__"